import React, { Fragment } from 'react';

const CurriculumLoading = () => (
  <Fragment>
    <section className="pairin-curriculum-courses">
      <div className="course">
        <div className="course-icon">
          <div className="course-icon-loading" />
        </div>
        <h4 className="course-name"></h4>
      </div>
      <div className="course">
        <div className="course-icon">
          <div className="course-icon-loading" />
        </div>
        <h4 className="course-name"></h4>
      </div>
      <div className="course">
        <div className="course-icon">
          <div className="course-icon-loading" />
        </div>
        <h4 className="course-name"></h4>
      </div>
      <div className="course">
        <div className="course-icon">
          <div className="course-icon-loading" />
        </div>
        <h4 className="course-name"></h4>
      </div>
    </section>
  </Fragment>
);

export default CurriculumLoading;
